import styled from "styled-components";
import { ThemeCustom } from "../Utils";

export const AppName = styled.div`
  font-family: ${ThemeCustom.fonts.appName}, cursive;
  font-size: 38px;
  color: ${(props) => (props.color ? props.color : "red")};
`;
